import { get } from "cartovistaExtend/appTools/Alerts";
import { downloadBlob } from "cartovistaExtend/utils/ServerUtils";
import "styles/DescriptionPanel.css";

var alertSuccess = $(get("DescriptionPanel_AddAlertSuccess")).addClass("show"),
    alertWarning = $(get("DescriptionPanel_AddAlertWarning")).addClass("show"),
    panelBtnSpanHtml = '<span class="cv-icon bi bi-journals"></span>&nbsp;Descriptions',
    panelHtml = '<div id="DescriptionPanel_container">' +
                    '<span id="DescriptionPanel_dropDown"></span>' +
                    '<span id="DescriptionPanel_download" class="float-end">' +
                        '<button id="DescriptionPanel_downloadBtn" class="cv-button k-button k-button-icon" type="button" title="Exporter les descriptions au format Word"><span class="k-sprite cv-icon cv-icon-export"></span></button><span id="DescriptionPanel_downloadDropDown"></span>' +
                    '</span>' +
                    '<textarea id="DescriptionPanel_textareaInput" class="form-control editionAllowed" maxlength="10000"></textarea>' +
                    '<span id="DescriptionPanel_alertContainer">' + alertSuccess + '</span>' +
                '</div>';
export default class App {
    constructor() {
        window.cartovista.addOneTimeEventListener(cartovista.EVENTS.MAP_LOADED + "_" + C.MAP.ID, this._onCartoVistaMapLoaded, this);
        window.cartovista.addEventListener("DecoupagePanel_DescriptionBtnClicked", this._onPanelDescriptionBtnClicked, this);
        window.cartovista.addEventListener("SectorsDatastore_SectorDataCodeChanged", this._onSectorDataCodeChanged, this);
        window.cartovista.addEventListener("SectorsDatastore_SectorsDataAdded", this._onSectorsDataAdded, this);
        window.cartovista.addEventListener("SectorsDatastore_SectorsDataDeleted", this._onSectorsDataDeleted, this);
        window.cartovista.addEventListener("SectorsDatastore_SectorDataDescriptionDirtyChanged", this._onSectorDataDescriptionDirtyChanged, this);
        window.cartovista.addEventListener("AuthSession_UserLoggedIn", this._onAuthSessionUserLoggedIn, this);
        window.cartovista.addEventListener("ReloadDataTool_ReloadStarted", this._onReloadDataStarted, this);
        window.cartovista.addEventListener("ReloadDataTool_ReloadCompleted", this._onReloadDataCompleted, this);
        this._$panel = $(panelHtml);
        this._$dropDown = this._$panel.find("#DescriptionPanel_dropDown");
        this._$downloadBtn = this._$panel.find("#DescriptionPanel_downloadBtn");
        this._$downloadDropDown = this._$panel.find("#DescriptionPanel_downloadDropDown");
        this._$textareaInput = this._$panel.find("#DescriptionPanel_textareaInput");
        this._$textareaInput.on("input propertychange", _.debounce(this._onDescriptionPanel_textareaInputChanged, 250).bind(this));
        this._$alertContainer = this._$panel.find("#DescriptionPanel_alertContainer");
        this._$alertContainer.on("click", "button#DescriptionPanel_submitBtn", this._onSubmitBtnClicked.bind(this));
        this._$downloadBtn.click(this._onDownloadBtnClicked.bind(this));
        this._toggleInputsDisabledProperty(C.APP_TOOLS.AUTH_SESSION.USER.EDITION_ALLOWED ? false : true);
        this._dropDown;
        this._selectedDataItem;
        this._downloadDropDown;
         $(this._$downloadDropDown.kendoDropDownList({
            "dataSource": {
                "data": ["Active", "Toutes"]
            },
            "animation": false,
            "dataBound": $.proxy(function(evt) {
                this._downloadDropDown = evt.sender;
            }, this)
        }));
    }

    _onCartoVistaMapLoaded(evt) {
        this._map = window.cartovista.getMap(C.MAP.ID);
        this._map.addEventListener(this._map.EVENTS.ACTIVE_THEME_SET_CHANGED, this._onActiveThemeSetChanged, this);
        this._descriptionPanel = window.cartovista.getUIController(this._map).findInstance("DescriptionPanel");
        $("#DescriptionPanel_btn").html(panelBtnSpanHtml);
        $(this._descriptionPanel.element).html(this._$panel);
    };

    _onAuthSessionUserLoggedIn(evt) {
        this._toggleInputsDisabledProperty(C.APP_TOOLS.AUTH_SESSION.USER.EDITION_ALLOWED ? false : true);
    };

    _toggleInputsDisabledProperty(disabled) {
        if (disabled) {
            this._$textareaInput.prop("disabled", true);
        } else {
            this._$textareaInput.prop("disabled", "");
        }
    };

    _onReloadDataStarted(evt) {
        this._toggleInputsDisabledProperty(true);
    };

    _onReloadDataCompleted(evt) {
        this._toggleInputsDisabledProperty(C.APP_TOOLS.AUTH_SESSION.USER.EDITION_ALLOWED ? false : true);
    };

    _onActiveThemeSetChanged(evt) {
        if (this._map.activeThemeSet) {
            this._selectedDataItem = null;
            this._createDropDown();
        } else {
            this._dropDown.setDataSource([]);
            this._$textareaInput.val("");
            this._$alertContainer.html(alertSuccess);
        }
    };

    _onSectorsDataAdded(evt) {
        this._createDropDown();
    };

    _onSectorsDataDeleted(evt) {
        if (this._selectedDataItem) {
            if (_.find(evt.source, {"id" : this._selectedDataItem.id})) {
                this._selectedDataItem = null;
            }
        }
        this._createDropDown();
    };

    _onSectorDataCodeChanged(evt) {
        this._createDropDown();
    };

    _onPanelDescriptionBtnClicked(evt) {
        var sectorData = evt.source;
        var prevSelectedDataItem = this._selectedDataItem;
        this._dropDown.value(sectorData.id);
        this._dropDown.trigger("change");
        if (prevSelectedDataItem !== null && prevSelectedDataItem.id === this._selectedDataItem.id && this._descriptionPanel.isActive) {
            this._descriptionPanel.deactivate();
        } else {
            this._descriptionPanel.activate();
        }
    };

    _createDropDown() {
        this._$dropDown.kendoDropDownList({
            "dataSource": {
                "data": _.map(window.sectorsDataStore.getSectorsData(this._map._scenarioId), function(sectorData) {
                            return {"id": sectorData.id, "name": sectorData.name, "code": sectorData.code, "group": sectorData.group};
                        })
            },
            "dataTextField": "name",
            "dataValueField": "id",
            "animation": false,
            "dataBound": $.proxy(function(evt) {
                this._dropDown = evt.sender;
                if (this._selectedDataItem) {
                    this._dropDown.value(this._selectedDataItem.id);
                }
                this._selectedDataItem = this._dropDown.dataItem();
                this._onDropDownValueChanged();
            }, this),
            "change": $.proxy(function(evt) {
                this._selectedDataItem = this._dropDown.dataItem();
                this._onDropDownValueChanged();
            }, this)
        });
    };

    _onDropDownValueChanged(evt) {
        if (this._selectedDataItem) {
            var sectorData = window.sectorsDataStore.getSectorsData(this._map._scenarioId, this._selectedDataItem.group, this._selectedDataItem.code);
            this._$textareaInput.val(sectorData.description);
            this._toggleSubmitBtn();
        }
    };

    _onDescriptionPanel_textareaInputChanged(evt) {
        var value = this._$textareaInput.val();
        var sectorData = window.sectorsDataStore.getSectorsData(this._map._scenarioId, this._selectedDataItem.group, this._selectedDataItem.code);
        sectorData.description = value.length ? value : null;
    };

    _onSubmitBtnClicked(evt) {
        var sectorData = window.sectorsDataStore.getSectorsData(this._map._scenarioId, this._selectedDataItem.group, this._selectedDataItem.code);
        window.sectorsDataStore._updateSectors([sectorData], [C.DATASTORES.SECTORS_DATA.ATTRIBUTES.DESCRIPTION])
            .then(function() {
                sectorData.descriptionDirty = false;
            }.bind(this))
            .catch(function() {
            }.bind(this));
    };

    _onSectorDataDescriptionDirtyChanged(evt) {
        this._toggleSubmitBtn();
    };

    _toggleSubmitBtn() {
        var sectorData = window.sectorsDataStore.getSectorsData(this._map._scenarioId, this._selectedDataItem.group, this._selectedDataItem.code);
        if (sectorData.descriptionDirty) {
            this._$alertContainer.html(alertWarning);
        } else {
            this._$alertContainer.html(alertSuccess);
        }
    };

    _onDownloadBtnClicked(evt) {
        switch (this._downloadDropDown.value()) {
            case "Active":
                this._downloadDescriptionAsDoc([window.sectorsDataStore.getSectorsData(this._map._scenarioId, this._selectedDataItem.group, this._selectedDataItem.code)]);
                break;
            case "Toutes":
                this._downloadDescriptionAsDoc(window.sectorsDataStore.getSectorsData(this._map._scenarioId));
                break;
            default:
                throw new Error("DescriptionPanel._onDownloadBtnClicked() - this._downloadDropDown.value() : " + this._downloadDropDown.value() + " is invalid.");
        }
    };

    _downloadDescriptionAsDoc(sectorsData) {
        if (sectorsData.length) {
            var docHtml = '<html>' +
                            'xmlns:office="urn:schemas-microsoft-com:office:office"' +
                            'xmlns:word="urn:schemas-microsoft-com:office:word"' +
                            'xmlns="http://www.w3.org/TR/REC-html40"' +
                            '<head>' +
                                '<meta charset="utf-8"/>' +
                                '<xml>' +
                                    '<word:WordDocument>' +
                                        '<word:View>Print</word:View>' +
                                        '<word:Zoom>90</word:Zoom>' +
                                        '<word:DoNotOptimizeForBrowser/>' +
                                    '</word:WordDocument>' +
                                '</xml>' +
                            '</head>' +
                            '<body>' +
                                '<p style="text-align:center; font-size:18; font-weight:bold;">' + this._map.mapTitle + '</p>' +
                                '<p style="text-align:center; font-size:14px; font-style:italic;">Descriptions techniques - ' + this._map.getThemeSet(this._map._scenarioId).title + '</p>' +
                                _.map(sectorsData, function(sectorData) {
                                    return '<p><p><b>' + sectorData.name + '</b></p>' + (sectorData.description ? sectorData.description.replace(/\n/g, "<br>") : "") + '</p><br>';
                                }).join(""); +
                            '</body>' +
                        '</html>';

            var filename = "Descriptions_CS_" + C.APP_TOOLS.AUTH_SESSION.USER.CD_CS + ".doc";
            downloadBlob(docHtml, filename, "application/msword");
        }
    };
}
